export interface AuthData {
    user: object,
    token: string
}

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const RESET_LOGIN = 'RESET_LOGIN';
export const EXPIRE_TOKEN_CLIENT = 'EXPIRE_TOKEN_CLIENT';

export const FETCH_DATA = 'FETCH_DATA';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR';

export const LOGOUT = 'LOGOUT';

export const UPDATE_FORM_SIGNUP = 'UPDATE_FORM_SIGNUP';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILD = 'LOGOUT_FAILD';

export const UPDATE_IDLE_TIME_CLIENT = 'UPDATE_IDLE_TIME_CLIENT';
export const UPDATE_TIME_RESUME_CLIENT = 'UPDATE_TIME_RESUME_CLIENT';

export const UPDATE_INFO_USER = 'UPDATE_INFO_USER';

export const UPDATE_DATA_FORM_AUTH = 'UPDATE_DATA_FORM_AUTH';

export const FETCH_ME_DATA = 'FETCH_ME_DATA';
export const FETCH_ME_DATA_SUCCESS = 'FETCH_ME_DATA_SUCCESS';
export const FETCH_ME_DATA_ERROR = 'FETCH_ME_DATA_ERROR';
